import React, { type FC } from 'react'

import {
    type CybusDetailedMapping,
    selectDeletableLoadedDetailedMapping,
    selectDisabableLoadedDetailedMapping,
    selectEnabableLoadedDetailedMapping,
    selectMapping,
    Translation,
} from '../../../../domain'

import { ResourceDetails, type ResourceDetailsModalsProps } from '../../Resources'
import { DeleteModal, DisableModal, EnableModal } from '../Bulk'
import { Content } from './Content'
import { HeaderActions } from './HeaderActions'
import { HeaderDetails } from './HeaderDetails'

const Modals: FC<ResourceDetailsModalsProps> = ({ leave }) => {
    return (
        <>
            <EnableModal mappingSelector={selectEnabableLoadedDetailedMapping} />
            <DisableModal mappingSelector={selectDisabableLoadedDetailedMapping} />
            <DeleteModal mappingSelector={selectDeletableLoadedDetailedMapping} onConfirmed={leave} />
        </>
    )
}

export const Details: FC = () => (
    <ResourceDetails<CybusDetailedMapping>
        subscriptionUsecase="manageMappingUsecase"
        resourceSelector={selectMapping}
        notFoundTitle={Translation.MAPPING_NOT_FOUND}
        modals={Modals}
        content={Content}
        headerResourceName={Translation.MAPPING}
        headerName="name"
        headerActions={HeaderActions}
        infoTitle={Translation.MAPPING_DETAILS_DOCUMENTATION_TITLE}
        infoBody={Translation.MAPPING_DETAILS_DOCUMENTATION_BODY}
        headerDetails={HeaderDetails}
    />
)
